import * as React from 'react';

import {SubTitleMedium} from '@spaced-out/ui-design-system/lib/components/Text';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import AiRecruiterCard from 'src/components/dashboard/ai-recruiter-card';
import AiReceptionistCard from 'src/components/dashboard/ai-receptionist-card';

import css from './ai-team-section.css';


function AiTeamSection(): React.ReactElement {
  const {t} = useLabelTranslation();

  return (
    <section className={css.section}>
      <SubTitleMedium color="secondary">
        {t('AI_Team', 'AI Team')}
      </SubTitleMedium>
      <div className={css.cards}>
        <AiRecruiterCard />
        <AiReceptionistCard />
      </div>
    </section>
  );
}

export default AiTeamSection;
